export const validatePhoneNumber = (phoneNumber) => {
    // Define the regular expression for phone number validation for NL, DE, and BE
    const phoneRegex = /^(?:\+?(31|32|49))?[-. (]*\d{1,4}[-. )]*\d{1,4}[-. ]*\d{1,4}[-. ]*\d{1,9}$|^(?:\+?(31|32|49))?\d{9,14}$/;

    // Test the phone number against the regex
    return phoneRegex.test(phoneNumber);
}